import styled from 'styled-components'
import { ReactComponent as motorEasyLogo } from '../../images/affiliates/motoreasy logo.svg'

export const GapActivationConfirmationContatiner = styled.div`
  position: relative;
  border: 1px solid ${(props) => props.theme.inputBorderColour};
  border-radius: 20px;
  background: #fff;
  margin: 24px 10px 0px 10px;
  padding: 20px 20px 0 20px;
  text-align: left;
`
export const GapHeader = styled.div`
  display: flex;
`

export const GapTitle = styled.h3`
  font-family: ${(props) => props.theme.fontFamily};
  font-size: 22px;
  line-height: 1em;
  color: ${(props) => props.theme.priceComparison.headerColour};
  margin: 0;
  justify-self: start;
  padding: 0 0 15px;
  text-wrap: nowrap;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`

export const GapText = styled.p`
  font-family: ${(props) => props.theme.fontFamily};
  font-size: 14px;
  line-height: 1.2em;
  text-align: start;
  margin: 0;
  padding-bottom: 15px;

  @media (max-width: 768px) {
    font-size: 11px;
  }
`

export const GapModalStyles = styled.div`
  text-align: left;
`

export const MotorEasyLogo = styled(motorEasyLogo)`
  height: 30px;
  @media (max-width: 768px) {
    height: 17px;
    padding-left: 8px;
  }
`
